'use client';

import { useBunja } from 'bunja/react';
import { PropsWithChildren } from 'react';

import { SnackbarLayout } from '@flipster/react/design-system/snackbar';
import { AlertComponent } from '@flipster/ui/Alert';

import { useUserRegulationRedirect } from '@web/app/[locale]/_user-regulation-redirect';
import { rootPopupBunja } from '@web/app/_layout/root-popup';
import AuthRedirect from '@web/components/AuthRedirect';

const Template = ({ children }: PropsWithChildren) => {
  useBunja(rootPopupBunja);
  useUserRegulationRedirect();

  return (
    <>
      <SnackbarLayout />
      <AlertComponent />
      <AuthRedirect />

      {children}
    </>
  );
};

export default Template;
